import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { ButtonOK, ButtonCancel } from "../../Buttons/ButtonGroup/ButtonGroup";

const ConfirmModal = (props) => {
  const { t } = useTranslation();

  let cancelButton = null;
  if (!props.hideCancel) {
    cancelButton = <ButtonCancel onClick={() => props.actionCancel()} />;
  }

  let title = t("Global.confirm");

  if (props.title) title = props.title;

  const okLabel = props.okLabel ? props.okLabel : null;

  return (
    <Dialog open={true}>
      <DialogTitle id={"confirmation-dialog"}>{title}</DialogTitle>
      <DialogContent>{props.children}</DialogContent>
      <DialogActions>
        {cancelButton}
        <ButtonOK label={okLabel} onClick={() => props.actionOk()} />
      </DialogActions>
    </Dialog>
  );
};

export const DeleteConfirmModal = (props) => {
  const { t } = useTranslation();

  let cancelButton = null;
  if (!props.hideCancel) {
    cancelButton = <ButtonCancel onClick={() => props.actionCancel()} />;
  }

  let title = t("Global.confirm");

  if (props.title) title = props.title;

  return (
    <Dialog open={true} className={"delete-confirmation-modal"}>
      <DialogTitle id={"confirmation-dialog"}>{title}</DialogTitle>
      <DialogContent>{props.children}</DialogContent>
      <DialogActions>
        {cancelButton}
        <Button
          variant="contained"
          className={"delete-button-red"}
          onClick={() => props.actionOk()}
        >
          {t("Global.delete")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const LeavePageModal = (props) => {
  return (
    <Dialog open={true} className={"delete-confirmation-modal"}>
      <DialogTitle id={"confirmation-dialog"}>Confirmation</DialogTitle>
      <DialogContent>Do you really want to leave this page?</DialogContent>
      <DialogActions>
        <Button
          onClick={props.actionCancel}
          variant={"contained"}
          color={"secondary"}
        >
          No
        </Button>
        <Button
          variant="contained"
          className={"delete-button-red"}
          onClick={() => props.actionOk()}
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const LeaveSaveModal = (props) => {
  return (
    <Dialog open={true} className={"delete-confirmation-modal"}>
      <DialogTitle
        id={"confirmation-dialog"}
        style={{
          fontSize: "2em",
          fontWeight: "bold",
          textAlign: "center",
        }}
      >
        Confirmation
      </DialogTitle>
      <DialogContent>Do you want to Save Scenario first?</DialogContent>
      <DialogActions style={{ margin: "0 auto" }}>
        <Button
          onClick={props.actionYes}
          variant="contained"
          className={"delete-button-red"}
        >
          Yes
        </Button>
        <Button
          onClick={props.actionNo}
          variant={"contained"}
          color={"secondary"}
        >
          No
        </Button>
        <Button
          onClick={props.actionCancel}
          variant={"contained"}
          color={"secondary"}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmModal;
